import {Component, Input, OnInit} from '@angular/core';
import {I18nService} from '../../../../shared/services/i18n.service';
import {
  BusinessCardOrderDetailInterface,
  BusinessCardOrderDetailItem,
  BusinessCardOrderInterface
} from '../../../../models/sharedinterface';
import * as moment from 'moment';
import {GlobalsService} from '../../../../shared/services/globals.service';
import {ApiFactoryService} from '../../../../shared/services/api-factory.service';
import {BcApi} from '../../../../models/bc-api';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../../../security/authentication.service';

export class Document {
  templateLabel: string;
  quantity: number;
  // Template fields
  [key: string]: any;
  constructor(businessCardOrderDetailItem: BusinessCardOrderDetailItem) {
    this.templateLabel = businessCardOrderDetailItem.documentConfigArray.doDocumentconfigtemplateArray.label;
    this.quantity = businessCardOrderDetailItem.quantity;
    const fields = businessCardOrderDetailItem.documentConfigArray.fieldValues;
    for (const field of Object.keys(fields)) {
      this[field] = fields[field];
    }
  }
}

@Component({
  selector: 'app-business-card-order-details',
  templateUrl: './business-card-order-details.component.html',
  styleUrls: ['./business-card-order-details.component.scss']
})
export class BusinessCardOrderDetailsComponent implements OnInit {

  serverRoot: string;

  bcApi: BcApi;

  @Input() order: BusinessCardOrderInterface;

  orderDetails: BusinessCardOrderDetailInterface;

  documentLists: {
    [documentType: string]: {
      documentTypeLabel: string;
      displayFields: string[];
      documents: Document[];
    }
  };

  constructor(
    public i18n: I18nService,
    private router: Router,
    private globalService: GlobalsService,
    private apifactory: ApiFactoryService,
    private authservice: AuthenticationService
  ) {
    this.bcApi = this.apifactory.createBcApi();
    this.serverRoot = this.globalService.getBCapiroot();
  }

  ngOnInit(): void {

    // TODO: loads order details
    // orderDetails = ...
    const query = this.bcApi.getOrderDetails(this.order.id);
    query.subscribe((allresults: any) => {
        this.orderDetails = allresults.results ;
        this.documentLists = {};

        // Sets document lists
        for (const item of this.orderDetails.items) {

          const documentType = item.documentConfigArray.doDocumentconfigtemplateArray.documenttypeArray;

          // Creates list if inexistant
          if (!this.documentLists[documentType.key]) {
            this.documentLists[documentType.key] = {
              documentTypeLabel: documentType.label,
              displayFields: documentType.displayColumns.split(','),
              documents: []
            };
          }

          // Adds document item
          this.documentLists[documentType.key].documents.push(new Document(item));
        }
      },
      error => {
        if (error.status === 403) { // Session expired
          this.authservice.setLoggedin(false);
          this.router.navigate(['']);
        }
      });
  }

  getFormattedDate(date) {
    return moment(new Date(date)).format('DD/MM/YYYY HH:mm');
  }

  getDocumentTypeKeys() {
    return Object.keys(this.documentLists);
  }
}
